import router from "@/router";
import {getValue, goToFireStore} from "@/globalFunctions";
import {getProspects} from "@/data/api/prospect";
import i18n from "@/lang";

export const filters = [
    {
        field: "sort",
        clearable: true,
        options: [
            { label: 'table.order.id-asc', key: 'Id-asc' },
            { label: 'table.order.id-desc', key: 'Id-desc' },
            { label: 'table.order.email-asc', key: 'Email-asc' },
            { label: 'table.order.email-desc', key: 'Email-desc' },
            { label: 'table.order.last-interaction-asc', key: 'LastInteraction-asc' },
            { label: 'table.order.last-interaction-desc', key: 'LastInteraction-desc' },
        ],
        placeholder: 'table.sort'
    }
];

export const columns = [
    {
        label: 'table.email',
        field: "Email",
    },
    {
        label: 'table.status',
        field: "Status",
        formatter: (x : any) => {
            return i18n.t("prospect-info.status." + x);
        }
    },
    {
        label: 'table.last-interaction',
        field: 'LastInteraction',
        formatter: (x : any) => {
            return new Date(x).toLocaleString();
        }
    }
];

export const actions = [
    {
        label: 'table.info',
        type: 'info',
        icon: "info",
        click: (row : any) => {
            router.push("/ecommerce/prospects/" + row.Id);
        }
    },
    {
        label: 'table.to-firestore',
        type: 'warning',
        icon: "local_fire_department",
        click: (row : any) => {
            goToFireStore({
                type: "prospect",
                prospectId: row.Id
            });
        }
    }
];

export const dialogs = {}

export const entryKey = "uid";

export const getData = async (listQuery : any) => {
    // Get items
    const {data} = await getProspects();
    let items = data;

    // Query

    // Sort
    if (listQuery.sort){
        const [field, order] = listQuery.sort.split("-")
        items = items.sort((a: any, b: any) => {
            if(getValue(a, field) < getValue(b, field)) { return order === 'asc' ? -1 : 1; }
            if(getValue(a, field) > getValue(b, field)) { return order === 'asc' ? 1 : -1; }
            return 0;
        });
    }

    return {
        data: {
            items: items,
            total: items.length
        }
    };
};
